// TinyMCE's font size format wraps only text in a span, so a blank line made of <br>s keeps
// its block's size. Setting the size on every block the selection fully covers lets those
// lines follow it too, while a few words selected inside a paragraph leave it alone.

const isBlank = (text: string) => text.trim() === '';

const textBefore = (block: Element, node: Node, offset: number) => {
  const range = block.ownerDocument.createRange();
  range.setStart(block, 0);
  range.setEnd(node, offset);
  return range.toString();
};

const textAfter = (block: Element, node: Node, offset: number) => {
  const range = block.ownerDocument.createRange();
  range.setStart(node, offset);
  range.setEnd(block, block.childNodes.length);
  return range.toString();
};

export const isFullySelected = (selection: Range, block: Element): boolean => {
  if (!selection.intersectsNode(block)) return false;

  const startsInside = block.contains(selection.startContainer);
  const endsInside = block.contains(selection.endContainer);
  return (
    (!startsInside ||
      isBlank(textBefore(block, selection.startContainer, selection.startOffset))) &&
    (!endsInside || isBlank(textAfter(block, selection.endContainer, selection.endOffset)))
  );
};

export const sizeFullySelectedBlocks = (
  selection: Range,
  blocks: Element[],
  size: string,
  setFontSize: (block: Element, size: string) => void
): void => {
  blocks
    .filter((block) => isFullySelected(selection, block))
    .forEach((block) => setFontSize(block, size));
};
